import { useUser } from '@ad-lucy/gateway-provider';
import { useCreateCampaignInBookingPermissionQuery } from '@codegen';

export function useUserCanCreateCampaignInBooking() {
  const user = useUser();
  const userCanBook = user.require({
    or: [
      'booking:view', // permission to enter new booking flow
      'campaign:booking', // permission to book an existing campaign from the dashboard
      'campaign.preview.booking:view', // permission to book an existing campaign from the preview
    ],
  });

  const { data, loading } = useCreateCampaignInBookingPermissionQuery({
    fetchPolicy: 'cache-first',
  });
  const hasExternalProductAvailable = Boolean(
    data?.productFamilies?.edges?.length,
  );

  return {
    loading,
    isAllowed: userCanBook && hasExternalProductAvailable,
  };
}
